<!-- OPEN CMDK -->
@if (searchOpen) {
  <app-search-bar
    (close)="searchOpen = false"
    (onSearch)="handleSearch($event)"
  ></app-search-bar>
}

<!-- HEADER -->
<div class="banner-block" [style.height.px]="bannerHeight()"></div>

<nav id="navbar" class="site-navbar py-lg-3">
  <div class="container-fluid navbar-main px-0 px-lg-5">
    <div class="brand-row">
      <button
        type="button"
        class="btn d-md-none"
        data-bs-toggle="offcanvas"
        data-bs-target="#mobileMenu"
        aria-controls="mobileMenu"
      >
        <i class="fas fa-bars"></i>
      </button>

      <div class="brand-logos ps-md-3">
        <a class="navbar-brand" routerLink="/" aria-label="Liber">
          <img src="/img/logov2.webp" alt="Liber" height="30" />
        </a>

        <a class="navbar-brand" routerLink="/">
          <img
            class="d-md-none"
            src="/img/logo-ac-sm.webp"
            height="55"
            alt="Arte y Cultura"
          />
        </a>

        <!-- <div class="navbar-brand">
          <img
            class="d-md-none"
            src="/img/logo-opus.png"
            height="55"
            alt="Arte y Cultura"
          />
        </div> -->
      </div>

      <div class="brand-partners">
        <a
          href="https://www.centroricardobsalinaspliego.org/arteycultura"
          target="_blank"
          rel="noopener"
        >
          <img src="/img/logo-arte.webp" alt="Arte y Cultura" />
        </a>

        <a
          href="https://www.centroricardobsalinaspliego.org"
          target="_blank"
          rel="noopener"
        >
          <img
            src="/img/rbs_solo.webp"
            alt="Centro Ricardo B. Salinas Pliego"
          />
        </a>
      </div>
    </div>

    <div class="navbar-collapse d-none d-md-flex mt-3" id="mainNavigation">
      <ul class="navbar-nav primary-links">
        @for (item of items; track $index) {
          @if (item.children) {
            <li class="nav-item dropdown">
              <button
                class="nav-link dropdown-toggle"
                [ngClass]="item?.variant ?? ''"
                role="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                {{ item.label }}
              </button>

              <ul class="dropdown-menu" [id]="'menu-' + item.label">
                @for (section of item.children; track section.link) {
                  <li>
                    <a
                      class="dropdown-item"
                      [routerLink]="section.link"
                      routerLinkActive="active"
                      [routerLinkActiveOptions]="{ exact: true }"
                    >
                      {{ section.label }}
                    </a>
                  </li>
                }
              </ul>
            </li>
          } @else {
            <li class="nav-item">
              <a
                class="nav-link"
                [ngClass]="item?.variant ?? ''"
                [routerLink]="item.link"
                routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }"
              >
                {{ item.label }}
              </a>
            </li>
          }
        }
      </ul>

      <ul class="navbar-nav secondary-links ms-auto">
        @for (item of secondaryItems; track $index) {
          <li class="nav-item">
            <a
              class="nav-link fw-light"
              [ngClass]="item?.variant ?? ''"
              [routerLink]="item.link"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }"
            >
              {{ item.label }}
            </a>
          </li>
        }

        <li class="nav-item">
          <button
            type="button"
            class="btn search-toggle"
            (click)="toggleSearch()"
            aria-label="Buscar"
          >
            <img src="/img/search.svg" width="20" alt="Buscar" />
          </button>
        </li>
      </ul>

      <ul class="navbar-nav social-links">
        @for (social of socialLinks; track social.url) {
          <li class="nav-item">
            <a
              [href]="social.url"
              target="_blank"
              rel="noopener"
              [attr.aria-label]="social.label"
              class="social-link"
            >
              <i [class]="social.icon"></i>
            </a>
          </li>
        }

        <!-- <li class="nav-item opus-logo">
          <img src="/img/logo-opus.png" height="35" alt="Logo OPUS" class="" />
        </li> -->
      </ul>
    </div>
  </div>

  <div
    class="offcanvas offcanvas-top"
    tabindex="-1"
    id="mobileMenu"
    aria-labelledby="mobileMenuLabel"
  >
    <div class="offcanvas-header">
      <button
        type="button"
        class="btn-close text-reset ms-0 me-auto"
        data-bs-dismiss="offcanvas"
        aria-label="Close"
      ></button>

      <div class="brand-logos ps-md-3">
        <a
          class="navbar-brand"
          routerLink="/"
          aria-label="Liber"
          data-bs-dismiss="offcanvas"
        >
          <img src="/img/logov2.webp" alt="Liber" height="30" />
        </a>

        <a class="navbar-brand" routerLink="/" data-bs-dismiss="offcanvas">
          <img
            class="d-md-none"
            src="/img/logo-ac-sm.webp"
            height="55"
            alt="Arte y Cultura"
          />
        </a>
      </div>
    </div>

    <div class="offcanvas-body">
      <ul class="navbar-nav primary-links flex-column mb-3">
        @for (item of items; track $index) {
          @if (item.children) {
            <li class="nav-item dropdown">
              <a
                class="nav-link dropdown-toggle"
                [ngClass]="item?.variant ?? ''"
                href="#"
                role="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
                >{{ item.label }}</a
              >
              <ul class="dropdown-menu" [id]="'menu-' + item.label">
                @for (section of item.children; track section.link) {
                  <li>
                    <a
                      class="dropdown-item"
                      [routerLink]="[section.link]"
                      data-bs-dismiss="offcanvas"
                      >{{ section.label }}</a
                    >
                  </li>
                }
              </ul>
            </li>
          } @else {
            <li class="nav-item">
              <a
                class="nav-link"
                [ngClass]="item?.variant ?? ''"
                [routerLink]="item.link"
                routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }"
                data-bs-dismiss="offcanvas"
                >{{ item.label }}</a
              >
            </li>
          }
        }
      </ul>
      <ul class="navbar-nav secondary-links flex-column">
        @for (item of secondaryItems; track $index) {
          <li class="nav-item">
            <a
              class="nav-link fw-light"
              [ngClass]="item?.variant ?? ''"
              [routerLink]="item.link"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }"
              data-bs-dismiss="offcanvas"
              >{{ item.label }}</a
            >
          </li>
        }
      </ul>
    </div>
  </div>
</nav>
